var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FocusLayout',{attrs:{"title":_vm.$t('Refresh Password'),"subtitle":_vm.$t('We\'ll send you an email with instructions to renew your password.')}},[_c('ForgotPasswordForm',_vm._b({},'ForgotPasswordForm',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }